/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { Button } from "@mui/material";
import { LinkContext } from "cms/links/link-selector/context";

const ServiceListLinkAddComponent = () => {

    const {
        setOpen,
        link,
    } = useContext(LinkContext);

    const openLinkDialog = () => {
        setOpen(true);
    };

    return (
        <Fragment>
            {link && (
                <div style={{ width: "100%", display: "flex", flexDirection: "row", padding: "20px" }}>
                    <Button
                        variant='text'
                        onClick={openLinkDialog}
                    >Select Link</Button>
                </div>
            )}
        </Fragment>
    );
};

export { ServiceListLinkAddComponent as LinkAddComponent }; 
